export const normalizeApiEndpoint = (endpoint: string) => {
	const normalizedEndpoint = endpoint.replace(/\/+$/, '')

	return normalizedEndpoint.endsWith('/api') ? normalizedEndpoint : `${normalizedEndpoint}/api`
}
